<template>
  <div class="main">
    <base-card v-for="sandwich in sandwiches" :key="sandwich.name" class="card">
      <v-card-title>{{ sandwich.name }}</v-card-title>
      <v-card-text>{{ sandwich.text }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        {{ sandwich.price }}
      </v-card-actions>
    </base-card>
    <base-card color="#DC143C">
      <v-card-title class="flex text-center">Subs</v-card-title>
    </base-card>
    <base-card v-for="sub in subs" :key="sub.name">
      <v-card-title>{{ sub.name }}</v-card-title>
      <v-card-text>{{ sub.text }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        {{ sub.price }}
      </v-card-actions>
    </base-card>
    <base-card color="#DC143C">
      <v-card-title class="flex text-center">Fries</v-card-title>
    </base-card>
    <base-card>
      <v-card-title>Fries</v-card-title>
      <v-card-actions class="flex text-right">
        <v-spacer></v-spacer>
        Small 60 den. <br />
        Large 80 den.
      </v-card-actions>
    </base-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      sandwiches: [
        {
          name: "Plain burger",
          text: "Bun, burger patty, lettuce",
          price: "130 den.",
        },
        {
          name: "Hamburger",
          text: "Bun, burger patty, fries, lettuce",
          price: "160 den.",
        },
        {
          name: "Cheeseburger",
          text: "Bun, burger patty, cheese, fries, lettuce",
          price: "190 den.",
        },
        {
          name: "Sivi",
          text: "Bread, fries, lettuce",
          price: "120 den.",
        },
        {
          name: "Plain chicken burger",
          text: "Bun, chicken steak, lettuce",
          price: "150 den.",
        },
        {
          name: "Chicken burger",
          text: "Bread, chicken steak, fries, lettuce",
          price: "180 den.",
        },
        {
          name: "Crispy Chicken",
          text: "Bread, chicken steak rolled in breadcrumbs, fries, lettuce",
          price: "200 den.",
        },
        {
          name: "EXTRA CHICKEN",
          text: "Bread, chicken steak, cheese, fries, lettuce",
          price: "210 den.",
        },
        {
          name: "French",
          text: "Baguette, chicken ham, dairy cheese, fries, lettuce",
          price: "150 den.",
        },
        {
          name: "Combined",
          text: "Bread, chicken ham, dairy cheese, fries, lettuce",
          price: "160 den.",
        },
        {
          name: "Vegetarian",
          text: "Bread, cheese, mushrooms, fries, lettuce",
          price: "150 den.",
        },
        {
          name: "Hot dog",
          text: "Bun, one wiener, mustard",
          price: "80 den.",
        },
        {
          name: "Double hot dog",
          text: "Bun, two wieners, mustard",
          price: "100 den.",
        },
        {
          name: "Woody hot dog 1",
          text: "Bun, one „Woody“ sausage, mustard",
          price: "110 den.",
        },
        {
          name: "Woody hot dog 2",
          text: "Bun, two „Woody“ sausages, mustard",
          price: "140 den.",
        },
        {
          name: "Woody hot dog 1 with fries",
          text: "Bun, one „Woody“ sausage, fries, mustard",
          price: "150 den.",
        },
        {
          name: "Woody hot dog 2 with fries",
          text: "Bun, two „Woody“ sausages, fries, mustard",
          price: "180 den.",
        },
        {
          name: "Sandwich with 1 wiener",
          text: "Bread, one chicken wiener, mustard, fries, lettuce",
          price: "120 den.",
        },
        {
          name: "Sandwich with 2 wieners",
          text: "Bread, two chicken wiener, mustard, fries, lettuce",
          price: "140 den.",
        },

      ],
      subs: [
        {
          name: "Chicken sub",
          text: "Bread, chicken salad, sour cream, lettuce",
          price: "100 den.",
        },
        {
          name: "Chicken sandwich",
          text: "Bread, chicken ham, cheese, lettuce",
          price: "110 den.",
        },
        {
          name: "Kulen sandwich",
          text: "Bread, kulen, cheese, lettuce",
          price: "130 den.",
        },
      ],
    };
  },
};
</script>

<style scoped>
.main {
  min-height: 300vh;
  background: transparent;
}
</style>
